import {
  ExpandMore as ExpandMoreIcon,
  MoreVert as MoreVertIcon,
} from "@mui/icons-material";
import {
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Tooltip,
} from "@mui/material";
import React from "react";
import { useDrop } from "react-dnd";
import Swal from "sweetalert2";
import OrgApi from "../../../../../API/OrgApi";
import CreateOrgReq from "../../../../../Requests/Organizations/CreateOrgReq";
import DeleteOrgReq from "../../../../../Requests/Organizations/DeleteOrgReq";
import ManageMembers from "./../../../ManageMembers";
import fallbackImage from "../assets/building.png";
import "../../index.scss";
import CreateFile from "../../../../../Requests/CloudFile/CreateFileReq";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import _ from "lodash";

export default function Organization({
  org,
  onCollapse,
  collapsed,
  getOrgTree,
}) {
  const [contextMenu, setContextMenu] = React.useState(null);
  const [modelOpen, setModelOpen] = React.useState(false);
  function addMember() {
    setModelOpen(true);
    setContextMenu(null);
  }

  const handleClick = (event) => {
    // event.preventDefault();

    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
          }
        : null
    );
  };
  async function deleteOrg(id, name) {
    setContextMenu(null);
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          icon: "info",
          title: "Deleting Organization",
          text: "Please wait...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        let req = new DeleteOrgReq();
        req.int = id;
        req.string = name;
        OrgApi.DeleteSalesOrg(req).then((response) => {
          if (response.status.success) {
            Swal.fire({
              title: "Deleted!",
              text: "The Organization has been deleted.",
              icon: "success",
              didOpen: () => {
                Swal.hideLoading();
              },
            });
            getOrgTree();
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.status.message,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              showConfirmButton: true,
              didOpen: () => {
                Swal.hideLoading();
              },
            });
          }
        });
      }
    });
  }

  const createOrg = async (id, name, logo) => {
    Swal.fire({
      icon: "info",
      title: "Creating Organization",
      text: "Please wait...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    if (!name) {
      Swal.fire({
        icon: "error",
        title: "Name is required",
        text: "Please enter Name",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: true,
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      return;
    }

    let req = new CreateOrgReq();

    req.name = name;
    if (id) {
      req.parentOrgId = id;
    }
    let res = await OrgApi.CreateOrg(req);

    if (logo && res?.data?.id) {
      const storage = getStorage();
      const uniqueId = Date.now();
      const storageRef = ref(storage, `/SalesOrgLogo/${uniqueId}`);

      try {
        await uploadBytes(storageRef, logo);
        const downloadURL = await getDownloadURL(storageRef);

        let img = new CreateFile();
        img.name = logo.name;
        img.path = `/SalesOrgLogo/${uniqueId}`;
        img.url = downloadURL;
        img.fileType = "image";
        img.extension = logo.name.split(".").pop();
        img.fileSize = logo.size.toString();
        img.caption = "Sales Org Logo";
        img.salesOrgId = res.data.id;

        await OrgApi.UpdateOrgLogo(img);
      } catch (error) {
        console.error("Error uploading logo:", error);
        Swal.fire({
          icon: "warning",
          title: "Logo Upload Failed",
          text: "Organization was created but logo upload failed.",
        });
      }
    }

    if (res?.status?.success) {
      Swal.fire({
        icon: "success",
        title: "Organization Created",
        text: "Organization has been created",
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
      });

      getOrgTree();
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: res?.status?.message,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: true,
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    }
  };
  const updateOrg = async (id, name, logo) => {
    setContextMenu(null);
    let selectedFile = null;
    let orgName = name; // Initialize orgName with the existing name

    const logoPreview = logo
      ? `<img src="${logo}" style="height: 100%; width: auto; object-fit: contain;" />`
      : "";

    await Swal.fire({
      title: "Update Organization",
      html: `
        <div style="display: flex; justify-content: center; align-items: center; flex-direction: column;">
          <input id="org-name-input" class="swal2-input" placeholder="Enter Name" value="${name}"
            style="height: 60px; width: 100%; max-width: 500px; padding: 0 10px; border: 1px solid #ccc; border-radius: 8px; box-sizing: border-box;" />
          <input type="file" id="imageUpload" accept="image/*" style="display: none;" />
  
          <label for="imageUpload" class="createOrganizationUpload"
            style="display: inline-block; width: 100%; height: 60px; margin-top: 20px; padding: 0 10px; border: 1px solid #ccc; border-radius: 8px; box-sizing: border-box; cursor: pointer; white-space: nowrap; max-width: 500px;">
            <div style="display: flex; align-items: center; justify-content: space-between; height: 100%; width: 100%; overflow: hidden;">
              <div id="uploadedImagePreview" style="height: 100%; width: 30px;"></div>
              <p id="fileName" class="createOrganizationUploadText" style="margin: 0; color: rgb(0, 0, 0); padding-right: 10px;">Select File</p>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 17" fill="none" style="padding-left: 10px;">
                <path d="M5 12.9987H9C9.55 12.9987 10 12.5487 10 11.9987V6.99869H11.59C12.48 6.99869 12.93 5.91869 12.3 5.28869L7.71 0.698694C7.61749 0.60599 7.5076 0.532443 7.38662 0.482261C7.26565 0.43208 7.13597 0.40625 7.005 0.40625C6.87403 0.40625 6.74435 0.43208 6.62338 0.482261C6.5024 0.532443 6.39251 0.60599 6.3 0.698694L1.71 5.28869C1.08 5.91869 1.52 6.99869 2.41 6.99869H4V11.9987C4 12.5487 4.45 12.9987 5 12.9987ZM1 14.9987H13C13.55 14.9987 14 15.4487 14 15.9987C14 16.5487 13.55 16.9987 13 16.9987H1C0.45 16.9987 0 16.5487 0 15.9987C0 15.4487 0.45 14.9987 1 14.9987Z" fill="#2761D0"/>
              </svg>
            </div>
          </label>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Update",
      focusConfirm: false,
      didOpen: () => {
        const inputField = document.getElementById("org-name-input");

        if (inputField) {
          inputField.addEventListener("input", (event) => {
            orgName = event.target.value;
            console.log("Updated Organization Name:", orgName);
          });
        } else {
          console.error("Input field not found!");
        }

        const fileInput = document.getElementById("imageUpload");
        const fileNameText = document.getElementById("fileName");

        fileInput.addEventListener("change", (e) => {
          selectedFile = e.target.files[0];
          if (selectedFile) {
            fileNameText.textContent = selectedFile.name;

            const preview = document.getElementById("uploadedImagePreview");
            const reader = new FileReader();
            reader.onload = function (e) {
              preview.innerHTML = `<img src="${e.target.result}" style="height: 100%; width: auto;" />`;
            };
            reader.readAsDataURL(selectedFile);
          }
        });
      },
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          Swal.fire({
            icon: "info",
            title: "Updating Organization",
            text: "Please wait...",
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => Swal.showLoading(),
          });

          // Prepare the request
          let req = new CreateOrgReq();
          req.name = orgName; // Use the updated orgName from the input field
          req.parentOrgId = id;

          console.log("Request to API: ", req); // Log the request data for debugging

          let res = await OrgApi.UpdateSalesOrg(req);

          if (selectedFile) {
            const req02 = new CreateFile();
            let img = null;
            let downloadUrls = [];
            let filePaths = [];

            const storage = getStorage();

            const uploadAndGetData = async (file, type) => {
              const uniqueId = Date.now();
              const storageRef = ref(storage, `/SalesOrgLogo/${uniqueId}`);

              await uploadBytes(storageRef, file);

              const downloadURL = await getDownloadURL(storageRef);
              downloadUrls.push(downloadURL);
              filePaths.push(`/SalesOrgLogo/${uniqueId}`);
            };

            img = new CreateFile();

            await uploadAndGetData(selectedFile, "image");
            img.name = selectedFile.name;
            img.path = filePaths[0];
            img.url = downloadUrls[0];
            img.fileType = "image";
            img.extension = selectedFile?.name?.split(".").pop();
            img.fileSize = selectedFile.size.toString();
            img.caption = "Sales Org Logo";
            img.salesOrgId = id;

            console.log("img", img);

            let res02 = await OrgApi.UpdateOrgLogo(img);
          }

          if (res?.status?.success) {
            Swal.fire({
              title: "Updated!",
              text: "The Organization has been updated.",
              icon: "success",
              didOpen: () => {
                Swal.hideLoading();
              },
            });
            getOrgTree();
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: res?.status?.message,
              allowOutsideClick: false,
              showConfirmButton: true,
              didOpen: () => {
                Swal.hideLoading();
              },
            });
          }
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong. Please try again later.",
          allowOutsideClick: false,
          showConfirmButton: true,
        });
      });
  };

  const handleClose = () => {
    setContextMenu(null);
  };

  const triggerInputAlert = (id) => {
    setContextMenu(null);
    let selectedFile = null;

    Swal.fire({
      title: "Create an Organization",
      html: `
        <div style="display: flex; justify-content: center; align-items: center; flex-direction: column;">
          <input id="org-name-input" class="swal2-input" placeholder="Enter Name"
            style="height: 60px; width: 100%; max-width: 500px; padding: 0 10px; border: 1px solid #ccc; border-radius: 8px; box-sizing: border-box;" />
  
          <input type="file" id="imageUpload" accept="image/*" style="display: none;" />
  
          <label for="imageUpload" class="createOrganizationUpload"
            style="display: inline-block; width: 100%; height: 60px; margin-top: 20px; padding: 0 10px; border: 1px solid #ccc; border-radius: 8px; box-sizing: border-box; cursor: pointer; white-space: nowrap; max-width: 500px;">
            <div style="display: flex; align-items: center; justify-content: space-between; height: 100%; width: 100%; overflow: hidden;">
              <div id="uploadedImagePreview" style="height: 100%; width: 30px;"></div>
              <p id="fileName" class="createOrganizationUploadText" style="margin: 0; color: rgb(0, 0, 0); padding-right: 10px;">Select File</p>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 17" fill="none" style="padding-left: 10px;">
                <path d="M5 12.9987H9C9.55 12.9987 10 12.5487 10 11.9987V6.99869H11.59C12.48 6.99869 12.93 5.91869 12.3 5.28869L7.71 0.698694C7.61749 0.60599 7.5076 0.532443 7.38662 0.482261C7.26565 0.43208 7.13597 0.40625 7.005 0.40625C6.87403 0.40625 6.74435 0.43208 6.62338 0.482261C6.5024 0.532443 6.39251 0.60599 6.3 0.698694L1.71 5.28869C1.08 5.91869 1.52 6.99869 2.41 6.99869H4V11.9987C4 12.5487 4.45 12.9987 5 12.9987ZM1 14.9987H13C13.55 14.9987 14 15.4487 14 15.9987C14 16.5487 13.55 16.9987 13 16.9987H1C0.45 16.9987 0 16.5487 0 15.9987C0 15.4487 0.45 14.9987 1 14.9987Z" fill="#2761D0"/>
              </svg>
            </div>
          </label>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Create",
      focusConfirm: false,
      preConfirm: () => {
        const name = document.getElementById("org-name-input").value;
        if (!name) {
          Swal.showValidationMessage("Please enter a name");
          return false;
        }
        return { name, file: selectedFile };
      },
      didOpen: () => {
        const fileInput = document.getElementById("imageUpload");
        const fileNameText = document.getElementById("fileName");

        fileInput.addEventListener("change", (e) => {
          selectedFile = e.target.files[0];
          if (selectedFile) {
            fileNameText.textContent = selectedFile.name;

            // Optional: Show preview thumbnail
            const preview = document.getElementById("uploadedImagePreview");
            const reader = new FileReader();
            reader.onload = function (e) {
              preview.innerHTML = `<img src="${e.target.result}" style="height: 100%; width: auto;" />`;
            };
            reader.readAsDataURL(selectedFile);
          }
        });
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const { name, file } = result.value;
        createOrg(id, name, file); // passing the logo to your createOrg
      }
    });
  };

  const [{ canDrop, isOver }, drop] = useDrop({
    accept: "account",
    drop: () => ({ name: org.name }),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const isActive = canDrop && isOver;
  let backgroundColor = "white";

  if (isActive) {
    backgroundColor = "#ddffd2";
  } else if (canDrop) {
    backgroundColor = "#ffeedc";
  }

  return (
    <Card
      variant="outlined"
      sx={{
        backgroundColor,
        background: "white",
        display: "inline-block",
        borderRadius: 5,
        border: "3px solid #435873",
      }}
      ref={drop}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: "10px", // Optional spacing from top
        }}
      >
        <img
          src={org?.logo?.url || fallbackImage}
          alt="Logo"
          onError={(e) => {
            e.target.onerror = null; // prevents infinite loop
            e.target.src = fallbackImage;
          }}
          style={{
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            margin: "10px",
            border: "1px solid black",
            objectPosition: "center",
            objectFit: "cover",
          }}
        />
      </div>
      <Modal open={modelOpen} onClose={() => setModelOpen(false)}>
        <ManageMembers
          orgId={org?.id}
          name={org?.name}
          setModelOpen={setModelOpen}
        />
      </Modal>
      <CardHeader
        avatar={
          <Tooltip
            title={`${_.size(org?.childOrgs)} Sub Organization`}
            arrow
          ></Tooltip>
        }
        subheader={`${_.size(org?.childOrgs)} Sub Organization`}
        title={<h1 className="text-2xl">{org?.name}</h1>}
        action={
          <IconButton size="small" onClick={handleClick}>
            <MoreVertIcon />
          </IconButton>
        }
      />
      <Menu
        open={contextMenu !== null}
        onClose={handleClose}
        sx={{ "& .MuiMenu-paper": { backgroundColor: "white" } }}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu !== null
            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
            : undefined
        }
      >
        <MenuItem onClick={() => triggerInputAlert(org?.id)}>
          Add an Organization
        </MenuItem>

        <MenuItem onClick={() => addMember()}>Add Members</MenuItem>
        {org?.childOrgs?.length === 0 && (
          <MenuItem onClick={() => deleteOrg(org?.id, org?.name)}>
            Delete the Organization
          </MenuItem>
        )}
        {/* Code will be added here to update the organization*/}
        <MenuItem onClick={() => updateOrg(org?.id, org?.name, org?.logo)}>
          Update Organization
        </MenuItem>
      </Menu>
      <IconButton
        size="small"
        onClick={onCollapse}
        sx={{
          transform: collapsed ? "rotate(180deg)" : "rotate(0deg)",
          marginLeft: "auto",
          transition: (theme) =>
            theme.transitions.create("transform", {
              duration: theme.transitions.duration.short,
            }),
        }}
      >
        <ExpandMoreIcon />
      </IconButton>
    </Card>
  );
}
